// extracted by mini-css-extract-plugin
module.exports = {"power-backup-D":"D_power-backup-D__lJxRz"};